/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxIdWebFeaturesPlayManifestResponseFromJSON, } from '../models/index';
/**
 *
 */
export class ManifestApi extends runtime.BaseAPI {
    /**
     */
    async fxIdWebFeaturesPlayManifestEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling fxIdWebFeaturesPlayManifestEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/manifest/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesPlayManifestResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesPlayManifestEndpoint(game, initOverrides) {
        const response = await this.fxIdWebFeaturesPlayManifestEndpointRaw({ game: game }, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=ManifestApi.js.map